import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import PublicNav from "@/components/PublicNav";
import { CheckCircle2, Loader2, AlertTriangle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const { refresh, user } = useAuth();
  const [state, setState] = useState("pending"); // pending | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); setMsg("This link is missing its token."); return; }
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        setState("ok");
        try { await refresh(); } catch {}
        setTimeout(() => nav(user ? "/app" : "/login"), 1500);
      } catch (err) {
        setState("error");
        setMsg(err?.response?.data?.detail || "Verification failed");
      }
    })();
    // eslint-disable-next-line
  }, [token]);

  return (
    <div className="min-h-screen">
      <PublicNav />
      <div className="max-w-md mx-auto p-8" data-testid="verify-page">
        <div className="fx-panel p-8 text-center">
          {state === "pending" && (<>
            <Loader2 size={30} className="animate-spin mx-auto text-cyan-300" />
            <div className="mt-4 text-slate-200">Verifying your email…</div>
          </>)}
          {state === "ok" && (<>
            <CheckCircle2 size={30} className="mx-auto text-emerald-400" />
            <div className="mt-4 font-display text-xl font-semibold text-white">Email verified</div>
            <div className="text-sm text-slate-400 mt-1">Redirecting you now…</div>
          </>)}
          {state === "error" && (<>
            <AlertTriangle size={30} className="mx-auto text-amber-400" />
            <div className="mt-4 font-display text-xl font-semibold text-white">Could not verify</div>
            <div className="text-sm text-slate-400 mt-1">{msg}</div>
            <div className="mt-4 flex justify-center gap-3">
              <Link to="/login" className="text-cyan-300 hover:text-cyan-200 text-sm">Sign in</Link>
              <Link to="/signup" className="text-slate-400 hover:text-slate-200 text-sm">Create account</Link>
            </div>
          </>)}
        </div>
      </div>
    </div>
  );
}
